import { useMemo } from 'react'

import { useUserOrganizationSettings } from '@modules-deprecated/app/organization'

interface ExpenseRevampFeatureFlags {
  isRevampedPurchaseListEnabled: boolean
  areFlagsLoading: boolean
}

/**
 * Dedicate hook for managing expense revamp accesses / feature flags.
 *
 * Note that this may have overlap with Datadog feature flags and/or beta feature flags going forward.
 * For the revamped purchase list we're required to use organization settings as we need granular control
 * on our side across every organization. We don't want this to be a user accessible beta toggle immediately
 * as we don't intend for some flags to be untoggleable.
 */
export const useExpenseRevampFeatureFlags = (): ExpenseRevampFeatureFlags => {
  const { organizationSettings, isLoading } = useUserOrganizationSettings()

  const isRevampedPurchaseListEnabled = useMemo<boolean>(() => {
    return organizationSettings?.isRevampedPurchaseListEnabled === '1'
  }, [organizationSettings?.isRevampedPurchaseListEnabled])

  return useMemo(
    () => ({
      isRevampedPurchaseListEnabled,
      areFlagsLoading: isLoading,
    }),
    [isRevampedPurchaseListEnabled, isLoading],
  )
}
